import { CountType, TimePeriod } from 'app/model/CORE';

export interface Point3d {
    x: number;
    y: number;
    z: number;
}

export class ProvidesKey<T> {
    getKey: (item: T) => any;

    constructor(key: (item: T) => any) {
        this.getKey = key;
    }
}

export type RegulationPeriods = {
    calculationType: CountType;
    constraints: RegulationConstraint[];
    occupancyDuration?: number;
};

export type RegulationConstraint = {
    timePeriod: TimePeriod;
    rate: number;
    peakRate?: number;
};

export class MonitoredFlow {
    private static NEXT_ID = 0;
    uuid: number;
    flowName: string;
    tvIds: Array<string>;
    predefined?: boolean;

    constructor(uuid: number, flowName: string, tvIds: Array<string>, predefined?: boolean) {
        this.uuid = uuid;
        this.flowName = flowName;
        this.tvIds = tvIds;
        this.predefined = predefined;
    }
}
